/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */


import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {MdRippleModule, MdCommonModule, FocusOriginMonitor, ObserveContentModule} from '../core';
import {MdCheckbox} from './checkbox';
export class MdCheckboxModule {static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
  imports: [CommonModule, MdRippleModule, MdCommonModule, ObserveContentModule],
  exports: [MdCheckbox, MdCommonModule],
  declarations: [MdCheckbox],
  providers: [FocusOriginMonitor]
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function MdCheckboxModule_tsickle_Closure_declarations() {
/** @type {?} */
MdCheckboxModule.decorators;
/**
 * @nocollapse
 * @type {?}
 */
MdCheckboxModule.ctorParameters;
}



export {MD_CHECKBOX_CONTROL_VALUE_ACCESSOR,TransitionCheckState,MdCheckboxChange,MdCheckboxBase,_MdCheckboxMixinBase,MdCheckbox} from './checkbox';

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
